/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type NotificationsContainer_viewer = {
    readonly id: string;
    readonly " $fragmentRefs": FragmentRefs<"UserBoxContainer_viewer">;
    readonly " $refType": "NotificationsContainer_viewer";
};
export type NotificationsContainer_viewer$data = NotificationsContainer_viewer;
export type NotificationsContainer_viewer$key = {
    readonly " $data"?: NotificationsContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"NotificationsContainer_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "NotificationsContainer_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "UserBoxContainer_viewer"
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = 'd107cf03bee270f84ade4ee100c3abb3';
export default node;
